import _typeof from "@babel/runtime/helpers/typeof";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import ActionTypes from '../../constants/ActionTypes';
import { stateManagement } from '@gisatcz/ptr-utils';
import helpers from '../Components/helpers';
import { isMatch as _isMatch, findIndex as _findIndex, indexOf as _indexOf, isEmpty as _isEmpty, remove as _remove } from 'lodash';
export var INITIAL_STATE = {
  activeSetKey: null,
  activeMapKey: null,
  inUse: {
    maps: [],
    sets: []
  },
  maps: {},
  sets: {}
};
/**
 * Set active map key
 * @param state {Object}
 * @param mapKey {string}
 * @return {Object} updated state
 */

var setActiveMapKey = function setActiveMapKey(state, mapKey) {
  if (mapKey) {
    return _objectSpread(_objectSpread({}, state), {}, {
      activeMapKey: mapKey
    });
  } else {
    return state;
  }
};
/**
 * Add map to store
 * @param state {Object}
 * @param map {Object} map state
 * @return {Object} Updated state
 */


var addMap = function addMap(state, map) {
  if (map !== null && map !== void 0 && map.key) {
    return _objectSpread(_objectSpread({}, state), {}, {
      maps: _objectSpread(_objectSpread({}, state.maps), {}, _defineProperty({}, map.key, map))
    });
  } else {
    return state;
  }
};
/**
 * Add map set to store
 * @param state {Object}
 * @param mapSet {Object} map set state
 * @return {Object} Updated state
 */


var addMapSet = function addMapSet(state, mapSet) {
  if (mapSet !== null && mapSet !== void 0 && mapSet.key) {
    return _objectSpread(_objectSpread({}, state), {}, {
      sets: _objectSpread(_objectSpread({}, state.sets), {}, _defineProperty({}, mapSet.key, mapSet))
    });
  } else {
    return state;
  }
};
/**
 * Add map to map set
 * @param state {Object}
 * @param mapKey {string}
 * @param mapSetKey {string}
 * @return {Object} Updated state
 */


var addMapToSet = function addMapToSet(state, mapKey, mapSetKey) {
  if (mapKey && mapSetKey && state.sets[mapSetKey]) {
    return _objectSpread(_objectSpread({}, state), {}, {
      sets: _objectSpread(_objectSpread({}, state.sets), {}, _defineProperty({}, mapSetKey, _objectSpread(_objectSpread({}, state.sets[mapSetKey]), {}, {
        maps: state.sets[mapSetKey].maps ? [].concat(_toConsumableArray(state.sets[mapSetKey].maps), [mapKey]) : [mapKey]
      })))
    });
  } else {
    return state;
  }
};
/**
 * Remove map from map set
 * @param state {Object}
 * @param setKey {string}
 * @param mapKey {string}
 * @return {Object} updated state
 */


var removeMapFromSet = function removeMapFromSet(state, setKey, mapKey) {
  if (setKey && mapKey) {
    var _state$sets$setKey;

    var index = _indexOf((_state$sets$setKey = state.sets[setKey]) === null || _state$sets$setKey === void 0 ? void 0 : _state$sets$setKey.maps, mapKey);

    if (index > -1) {
      var updatedMaps = stateManagement.removeItemByIndex(state.sets[setKey].maps, index);
      return _objectSpread(_objectSpread({}, state), {}, {
        sets: _objectSpread(_objectSpread({}, state.sets), {}, _defineProperty({}, setKey, _objectSpread(_objectSpread({}, state.sets[setKey]), {}, {
          maps: updatedMaps
        })))
      });
    } else {
      return state;
    }
  } else {
    return state;
  }
};
/**
 * Remove map from store
 * @param state {Object}
 * @param mapKey {string}
 * @return {Object} Updated state
 */


var removeMap = function removeMap(state, mapKey) {
  if (mapKey && state.maps[mapKey]) {
    // eslint-disable-next-line no-unused-vars
    var _state$maps = state.maps,
        map = _state$maps[mapKey],
        restMaps = _objectWithoutProperties(_state$maps, [mapKey].map(_toPropertyKey));

    return _objectSpread(_objectSpread({}, state), {}, {
      maps: restMaps
    });
  } else {
    return state;
  }
};
/**
 * Remove map set from store
 * @param state {Object}
 * @param mapSetKey {string}
 * @return {Object} Updated state
 */


var removeMapSet = function removeMapSet(state, mapSetKey) {
  if (mapSetKey && state.sets[mapSetKey]) {
    // eslint-disable-next-line no-unused-vars
    var _state$sets = state.sets,
        set = _state$sets[mapSetKey],
        restSets = _objectWithoutProperties(_state$sets, [mapSetKey].map(_toPropertyKey));

    return _objectSpread(_objectSpread({}, state), {}, {
      sets: restSets
    });
  } else {
    return state;
  }
};
/**
 * Remove layer from map
 * @param state {Object}
 * @param mapKey {string}
 * @param layerKey {string}
 * @return {Object} Updated state
 */


var removeMapLayer = function removeMapLayer(state, mapKey, layerKey) {
  if (layerKey && mapKey) {
    var _state$maps$mapKey;

    var index = _findIndex((_state$maps$mapKey = state.maps[mapKey]) === null || _state$maps$mapKey === void 0 ? void 0 : _state$maps$mapKey.data.layers, {
      key: layerKey
    });

    if (index > -1) {
      var _state$maps$mapKey2;

      var updatedLayers = stateManagement.removeItemByIndex((_state$maps$mapKey2 = state.maps[mapKey]) === null || _state$maps$mapKey2 === void 0 ? void 0 : _state$maps$mapKey2.data.layers, index);
      return _objectSpread(_objectSpread({}, state), {}, {
        maps: _objectSpread(_objectSpread({}, state.maps), {}, _defineProperty({}, mapKey, _objectSpread(_objectSpread({}, state.maps[mapKey]), {}, {
          data: _objectSpread(_objectSpread({}, state.maps[mapKey].data), {}, {
            layers: updatedLayers
          })
        })))
      });
    } else {
      return state;
    }
  } else {
    return state;
  }
};
/**
 * Remove layers from map
 * @param state {Object}
 * @param mapKey {string}
 * @param layerKeys {Array}
 * @return {Object} Updated state
 */


var removeMapLayers = function removeMapLayers(state, mapKey, layerKeys) {
  if (layerKeys !== null && layerKeys !== void 0 && layerKeys.length && mapKey) {
    var _state$maps$mapKey3, _state$maps$mapKey3$d;

    var updatedLayers = _toConsumableArray((_state$maps$mapKey3 = state.maps[mapKey]) !== null && _state$maps$mapKey3 !== void 0 && (_state$maps$mapKey3$d = _state$maps$mapKey3.data) !== null && _state$maps$mapKey3$d !== void 0 && _state$maps$mapKey3$d.layers ? state.maps[mapKey].data.layers : []);

    layerKeys.forEach(function (layerKey) {
      var index = _findIndex(updatedLayers, {
        key: layerKey
      });

      if (index > -1) {
        updatedLayers = stateManagement.removeItemByIndex(updatedLayers, index);
      }
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      maps: _objectSpread(_objectSpread({}, state.maps), {}, _defineProperty({}, mapKey, _objectSpread(_objectSpread({}, state.maps[mapKey]), {}, {
        data: _objectSpread(_objectSpread({}, state.maps[mapKey].data), {}, {
          layers: updatedLayers
        })
      })))
    });
  } else {
    return state;
  }
};
/**
 * Remove layers satisfying filter from map
 * @param state {Object}
 * @param mapKey {string}
 * @param filter {object}
 * @return {Object} Updated state
 */


var removeMapLayersByFilter = function removeMapLayersByFilter(state, mapKey, filter) {
  if (!_isEmpty(filter) && mapKey) {
    var _state$maps$mapKey4, _state$maps$mapKey4$d;

    var mapLayers = _toConsumableArray((_state$maps$mapKey4 = state.maps[mapKey]) !== null && _state$maps$mapKey4 !== void 0 && (_state$maps$mapKey4$d = _state$maps$mapKey4.data) !== null && _state$maps$mapKey4$d !== void 0 && _state$maps$mapKey4$d.layers ? state.maps[mapKey].data.layers : []);

    var originalMapLayersLength = mapLayers.length; // remove layers satisfying filter

    _remove(mapLayers, function (l) {
      return _isMatch(l, filter);
    });

    if (originalMapLayersLength > 0 && originalMapLayersLength !== mapLayers.length) {
      return _objectSpread(_objectSpread({}, state), {}, {
        maps: _objectSpread(_objectSpread({}, state.maps), {}, _defineProperty({}, mapKey, _objectSpread(_objectSpread({}, state.maps[mapKey]), {}, {
          data: _objectSpread(_objectSpread({}, state.maps[mapKey].data), {}, {
            layers: mapLayers
          })
        })))
      });
    } else {
      return state;
    }
  } else {
    return state;
  }
};
/**
 * Remove all layers from map
 * @param state {Object}
 * @param mapKey {string}
 * @return {Object} Updated state
 */


var removeAllMapLayers = function removeAllMapLayers(state, mapKey) {
  var _state$maps$mapKey5, _state$maps$mapKey5$d, _state$maps$mapKey5$d2;

  if (mapKey && (_state$maps$mapKey5 = state.maps[mapKey]) !== null && _state$maps$mapKey5 !== void 0 && (_state$maps$mapKey5$d = _state$maps$mapKey5.data) !== null && _state$maps$mapKey5$d !== void 0 && (_state$maps$mapKey5$d2 = _state$maps$mapKey5$d.layers) !== null && _state$maps$mapKey5$d2 !== void 0 && _state$maps$mapKey5$d2.length) {
    return _objectSpread(_objectSpread({}, state), {}, {
      maps: _objectSpread(_objectSpread({}, state.maps), {}, _defineProperty({}, mapKey, _objectSpread(_objectSpread({}, state.maps[mapKey]), {}, {
        data: _objectSpread(_objectSpread({}, state.maps[mapKey].data), {}, {
          layers: []
        })
      })))
    });
  } else {
    return state;
  }
};
/**
 * Add layer states to map
 * @param state {Object}
 * @param mapKey {string}
 * @param layerStates {Array} A collection, where each object represents state of the layer
 * @return {Object} updated state
 */


var addMapLayers = function addMapLayers(state, mapKey, layerStates) {
  var _state$maps2;

  if (mapKey && layerStates && (_state$maps2 = state.maps) !== null && _state$maps2 !== void 0 && _state$maps2[mapKey]) {
    var _state$maps$mapKey$da;

    var oldLayers = (_state$maps$mapKey$da = state.maps[mapKey].data) === null || _state$maps$mapKey$da === void 0 ? void 0 : _state$maps$mapKey$da.layers;
    var updatedLayers = oldLayers ? [].concat(_toConsumableArray(oldLayers), _toConsumableArray(layerStates)) : layerStates;
    return _objectSpread(_objectSpread({}, state), {}, {
      maps: _objectSpread(_objectSpread({}, state.maps), {}, _defineProperty({}, mapKey, _objectSpread(_objectSpread({}, state.maps[mapKey]), {}, {
        data: state.maps[mapKey].data ? _objectSpread(_objectSpread({}, state.maps[mapKey].data), {}, {
          layers: updatedLayers
        }) : {
          layers: updatedLayers
        }
      })))
    });
  } else {
    return state;
  }
};
/**
 * Add layer to the specific position
 * @param state {Object}
 * @param mapKey {string}
 * @param layerState {Object}
 * @param index {number}
 * @return {Object} updated state
 */


var addMapLayerToIndex = function addMapLayerToIndex(state, mapKey, layerState, index) {
  var _state$maps3;

  if (mapKey && layerState && (_state$maps3 = state.maps) !== null && _state$maps3 !== void 0 && _state$maps3[mapKey]) {
    var _state$maps$mapKey$da2;

    var updatedLayers;
    var currentLayers = (_state$maps$mapKey$da2 = state.maps[mapKey].data) === null || _state$maps$mapKey$da2 === void 0 ? void 0 : _state$maps$mapKey$da2.layers;

    if (currentLayers) {
      if (index > -1 && index < currentLayers.length) {
        updatedLayers = stateManagement.addItemToIndex(currentLayers, index, layerState);
      } else {
        updatedLayers = [].concat(_toConsumableArray(currentLayers), [layerState]);
      }
    } else {
      updatedLayers = [layerState];
    }

    return _objectSpread(_objectSpread({}, state), {}, {
      maps: _objectSpread(_objectSpread({}, state.maps), {}, _defineProperty({}, mapKey, _objectSpread(_objectSpread({}, state.maps[mapKey]), {}, {
        data: state.maps[mapKey].data ? _objectSpread(_objectSpread({}, state.maps[mapKey].data), {}, {
          layers: updatedLayers
        }) : {
          layers: updatedLayers
        }
      })))
    });
  } else {
    return state;
  }
};
/**
 * Set styleKey to the specific layer of the specific map
 * @param state {Object}
 * @param mapKey {string}
 * @param layerKey {string}
 * @param styleKey {string} uuid
 * @return {Object} state
 */


var setMapLayerStyleKey = function setMapLayerStyleKey(state, mapKey, layerKey, styleKey) {
  var _state$maps$mapKey6, _state$maps$mapKey6$d;

  var layers = (_state$maps$mapKey6 = state.maps[mapKey]) === null || _state$maps$mapKey6 === void 0 ? void 0 : (_state$maps$mapKey6$d = _state$maps$mapKey6.data) === null || _state$maps$mapKey6$d === void 0 ? void 0 : _state$maps$mapKey6$d.layers;

  if (layers) {
    var updatedLayers = layers.map(function (item) {
      if (item.key === layerKey) {
        return _objectSpread(_objectSpread({}, item), {}, {
          styleKey: styleKey
        });
      } else {
        return item;
      }
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      maps: _objectSpread(_objectSpread({}, state.maps), {}, _defineProperty({}, mapKey, _objectSpread(_objectSpread({}, state.maps[mapKey]), {}, {
        data: _objectSpread(_objectSpread({}, state.maps[mapKey].data), {}, {
          layers: updatedLayers
        })
      })))
    });
  } else {
    return state;
  }
};
/**
 * Set map layer opacity
 * @param state {Object}
 * @param mapKey {string}
 * @param layerKey {string}
 * @param opacity {number}
 * @return {Object} state
 */


var setMapLayerOpacity = function setMapLayerOpacity(state, mapKey, layerKey, opacity) {
  var _state$maps$mapKey7, _state$maps$mapKey7$d;

  var layers = (_state$maps$mapKey7 = state.maps[mapKey]) === null || _state$maps$mapKey7 === void 0 ? void 0 : (_state$maps$mapKey7$d = _state$maps$mapKey7.data) === null || _state$maps$mapKey7$d === void 0 ? void 0 : _state$maps$mapKey7$d.layers;

  if (layers) {
    var updatedLayers = layers.map(function (item) {
      if (item.key === layerKey) {
        return _objectSpread(_objectSpread({}, item), {}, {
          opacity: opacity
        });
      } else {
        return item;
      }
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      maps: _objectSpread(_objectSpread({}, state.maps), {}, _defineProperty({}, mapKey, _objectSpread(_objectSpread({}, state.maps[mapKey]), {}, {
        data: _objectSpread(_objectSpread({}, state.maps[mapKey].data), {}, {
          layers: updatedLayers
        })
      })))
    });
  } else {
    return state;
  }
};
/**
 * Set map layer option
 * @param state {Object}
 * @param mapKey {string}
 * @param layerKey {string}
 * @param optionKey {string} Name of the property or path to property
 * @param optionValue {*}
 * @return {Object} state
 */


var setMapLayerOption = function setMapLayerOption(state, mapKey, layerKey, optionKey, optionValue) {
  var _state$maps$mapKey8, _state$maps$mapKey8$d;

  var layers = (_state$maps$mapKey8 = state.maps[mapKey]) === null || _state$maps$mapKey8 === void 0 ? void 0 : (_state$maps$mapKey8$d = _state$maps$mapKey8.data) === null || _state$maps$mapKey8$d === void 0 ? void 0 : _state$maps$mapKey8$d.layers;

  if (layers) {
    var updatedLayers = layers.map(function (item) {
      if (item.key === layerKey) {
        return _objectSpread(_objectSpread({}, item), {}, {
          options: helpers.setHelper(item.options || {}, optionKey.split('.'), optionValue)
        });
      } else {
        return item;
      }
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      maps: _objectSpread(_objectSpread({}, state.maps), {}, _defineProperty({}, mapKey, _objectSpread(_objectSpread({}, state.maps[mapKey]), {}, {
        data: _objectSpread(_objectSpread({}, state.maps[mapKey].data), {}, {
          layers: updatedLayers
        })
      })))
    });
  } else {
    return state;
  }
};
/**
 * Set map width and height
 * @param state {Object}
 * @param mapKey {string}
 * @param width {number} map width in px
 * @param height {number} map height in px
 * @return {Object} state
 */


var setMapViewport = function setMapViewport(state, mapKey, width, height) {
  var _state$maps4;

  if (mapKey && (_state$maps4 = state.maps) !== null && _state$maps4 !== void 0 && _state$maps4[mapKey] && width && height) {
    return _objectSpread(_objectSpread({}, state), {}, {
      maps: _objectSpread(_objectSpread({}, state.maps), {}, _defineProperty({}, mapKey, _objectSpread(_objectSpread({}, state.maps[mapKey]), {}, {
        data: state.maps[mapKey].data ? _objectSpread(_objectSpread({}, state.maps[mapKey].data), {}, {
          viewport: {
            width: width,
            height: height
          }
        }) : {
          viewport: {
            width: width,
            height: height
          }
        }
      })))
    });
  } else {
    return state;
  }
};
/**
 * Set active map of the map set
 * @param state {Object}
 * @param setKey {string}
 * @param mapKey {string}
 * @return {Object} state
 */


var setSetActiveMapKey = function setSetActiveMapKey(state, setKey, mapKey) {
  var _state$sets2;

  if (setKey && (_state$sets2 = state.sets) !== null && _state$sets2 !== void 0 && _state$sets2[setKey]) {
    return _objectSpread(_objectSpread({}, state), {}, {
      sets: _objectSpread(_objectSpread({}, state.sets), {}, _defineProperty({}, setKey, _objectSpread(_objectSpread({}, state.sets[setKey]), {}, {
        activeMapKey: mapKey
      })))
    });
  } else {
    return state;
  }
};
/**
 * Set map set background layer state
 * @param state {Object}
 * @param setKey {string}
 * @param backgroundLayer {Object} background layer state
 * @return {Object} state
 */


var setSetBackgroundLayer = function setSetBackgroundLayer(state, setKey, backgroundLayer) {
  var _state$sets3;

  if (setKey && (_state$sets3 = state.sets) !== null && _state$sets3 !== void 0 && _state$sets3[setKey] && backgroundLayer) {
    return _objectSpread(_objectSpread({}, state), {}, {
      sets: _objectSpread(_objectSpread({}, state.sets), {}, _defineProperty({}, setKey, _objectSpread(_objectSpread({}, state.sets[setKey]), {}, {
        data: _objectSpread(_objectSpread({}, state.sets[setKey].data), {}, {
          backgroundLayer: backgroundLayer
        })
      })))
    });
  } else {
    return state;
  }
};

var setMapSetSync = function setMapSetSync(state, mapSetKey, sync) {
  var _state$sets4;

  if (mapSetKey && (_state$sets4 = state.sets) !== null && _state$sets4 !== void 0 && _state$sets4[mapSetKey]) {
    return _objectSpread(_objectSpread({}, state), {}, {
      sets: _objectSpread(_objectSpread({}, state.sets), {}, _defineProperty({}, mapSetKey, _objectSpread(_objectSpread({}, state.sets[mapSetKey]), {}, {
        sync: sync
      })))
    });
  } else {
    return state;
  }
};
/**
 * Set map background layer state
 * @param state {Object}
 * @param mapKey {string}
 * @param backgroundLayer {Object} background layer state
 * @return {Object} state
 */


var setMapBackgroundLayer = function setMapBackgroundLayer(state, mapKey, backgroundLayer) {
  var _state$maps5;

  if (mapKey && (_state$maps5 = state.maps) !== null && _state$maps5 !== void 0 && _state$maps5[mapKey] && backgroundLayer) {
    return _objectSpread(_objectSpread({}, state), {}, {
      maps: _objectSpread(_objectSpread({}, state.maps), {}, _defineProperty({}, mapKey, _objectSpread(_objectSpread({}, state.maps[mapKey]), {}, {
        data: state.maps[mapKey].data ? _objectSpread(_objectSpread({}, state.maps[mapKey].data), {}, {
          backgroundLayer: backgroundLayer
        }) : {
          backgroundLayer: backgroundLayer
        }
      })))
    });
  } else {
    return state;
  }
};
/**
 * Set map set layers state
 * @param state {Object}
 * @param setKey {string}
 * @param layers {Object} layers state
 * @return {Object} state
 */


var setSetLayers = function setSetLayers(state, setKey, layers) {
  var _state$sets5;

  if (setKey && layers && (_state$sets5 = state.sets) !== null && _state$sets5 !== void 0 && _state$sets5[setKey]) {
    return _objectSpread(_objectSpread({}, state), {}, {
      sets: _objectSpread(_objectSpread({}, state.sets), {}, _defineProperty({}, setKey, _objectSpread(_objectSpread({}, state.sets[setKey]), {}, {
        data: state.sets[setKey].data ? _objectSpread(_objectSpread({}, state.sets[setKey].data), {}, {
          layers: layers
        }) : {
          layers: layers
        }
      })))
    });
  } else {
    return state;
  }
};
/**
 * Update whole map state
 * @param state {Object}
 * @param data {Object}
 * @return {Object}
 */


var update = function update(state, data) {
  return _objectSpread(_objectSpread({}, state), data);
};
/**
 * Update map view
 * @param state {Object}
 * @param mapKey {string}
 * @param updates {Object} map view updates
 * @return {Object} state
 */


var updateMapView = function updateMapView(state, mapKey, updates) {
  if (updates && !_isEmpty(updates)) {
    var _state$maps$mapKey$da3;

    return _objectSpread(_objectSpread({}, state), {}, {
      maps: _objectSpread(_objectSpread({}, state.maps), {}, _defineProperty({}, mapKey, _objectSpread(_objectSpread({}, state.maps[mapKey]), {}, {
        data: _objectSpread(_objectSpread({}, state.maps[mapKey].data), {}, {
          previousView: ((_state$maps$mapKey$da3 = state.maps[mapKey].data) === null || _state$maps$mapKey$da3 === void 0 ? void 0 : _state$maps$mapKey$da3.view) || null,
          view: state.maps[mapKey].data.view ? _objectSpread(_objectSpread({}, state.maps[mapKey].data.view), updates) : updates
        })
      })))
    });
  } else {
    return state;
  }
};
/**
 * Update map set view
 * @param state {Object}
 * @param setKey {string}
 * @param updates {Object} map view updates
 * @return {Object} state
 */


var updateSetView = function updateSetView(state, setKey, updates) {
  if (updates && !_isEmpty(updates)) {
    var _state$sets$setKey$da;

    return _objectSpread(_objectSpread({}, state), {}, {
      sets: _objectSpread(_objectSpread({}, state.sets), {}, _defineProperty({}, setKey, _objectSpread(_objectSpread({}, state.sets[setKey]), {}, {
        data: _objectSpread(_objectSpread({}, state.sets[setKey].data), {}, {
          previousView: ((_state$sets$setKey$da = state.sets[setKey].data) === null || _state$sets$setKey$da === void 0 ? void 0 : _state$sets$setKey$da.view) || null,
          view: state.sets[setKey].data.view ? _objectSpread(_objectSpread({}, state.sets[setKey].data.view), updates) : updates
        })
      })))
    });
  } else {
    return state;
  }
};
/**
 * Remove map usage
 * @param state {Object}
 * @param mapKey {string}
 * @return {Object} state
 */


var mapUseClear = function mapUseClear(state, mapKey) {
  if (mapKey) {
    var index = _indexOf(state.inUse.maps, mapKey);

    if (index > -1) {
      var updatedInUse = stateManagement.removeItemByIndex(state.inUse.maps, index);
      return _objectSpread(_objectSpread({}, state), {}, {
        inUse: _objectSpread(_objectSpread({}, state.inUse), {}, {
          maps: updatedInUse
        })
      });
    } else {
      return state;
    }
  } else {
    return state;
  }
};
/**
 * Remove map set usage
 * @param state {Object}
 * @param mapSetKey {string}
 * @return {Object} state
 */


var mapSetUseClear = function mapSetUseClear(state, mapSetKey) {
  if (mapSetKey) {
    var index = _indexOf(state.inUse.sets, mapSetKey);

    if (index > -1) {
      var updatedInUse = stateManagement.removeItemByIndex(state.inUse.sets, index);
      return _objectSpread(_objectSpread({}, state), {}, {
        inUse: _objectSpread(_objectSpread({}, state.inUse), {}, {
          sets: updatedInUse
        })
      });
    } else {
      return state;
    }
  } else {
    return state;
  }
};
/**
 * Register map usage
 * @param state {Object}
 * @param mapKey {string}
 * @return {Object} state
 */


var mapUseRegister = function mapUseRegister(state, mapKey) {
  if (mapKey) {
    return _objectSpread(_objectSpread({}, state), {}, {
      inUse: _objectSpread(_objectSpread({}, state.inUse), {}, {
        maps: [].concat(_toConsumableArray(state.inUse.maps), [mapKey])
      })
    });
  } else {
    return state;
  }
};
/**
 * Register map set usage
 * @param state {Object}
 * @param mapSetKey {string}
 * @return {Object} state
 */


var mapSetUseRegister = function mapSetUseRegister(state, mapSetKey) {
  if (mapSetKey) {
    return _objectSpread(_objectSpread({}, state), {}, {
      inUse: _objectSpread(_objectSpread({}, state.inUse), {}, {
        sets: [].concat(_toConsumableArray(state.inUse.sets), [mapSetKey])
      })
    });
  } else {
    return state;
  }
};

export default function tasksReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ActionTypes.MAPS.MAP.ADD:
      return addMap(state, action.map);

    case ActionTypes.MAPS.MAP.LAYERS.ADD:
      return addMapLayers(state, action.mapKey, action.layerStates);

    case ActionTypes.MAPS.MAP.LAYERS.ADD_TO_INDEX:
      return addMapLayerToIndex(state, action.mapKey, action.layerState, action.index);

    case ActionTypes.MAPS.MAP.LAYERS.REMOVE_LAYER:
      return removeMapLayer(state, action.mapKey, action.layerKey);

    case ActionTypes.MAPS.MAP.LAYERS.REMOVE_LAYERS:
      return removeMapLayers(state, action.mapKey, action.layerKeys);

    case ActionTypes.MAPS.MAP.LAYERS.REMOVE_LAYERS_BY_FILTER:
      return removeMapLayersByFilter(state, action.mapKey, action.filter);

    case ActionTypes.MAPS.MAP.LAYERS.REMOVE_ALL:
      return removeAllMapLayers(state, action.mapKey);

    case ActionTypes.MAPS.MAP.LAYERS.SET_OPACITY:
      return setMapLayerOpacity(state, action.mapKey, action.layerKey, action.opacity);

    case ActionTypes.MAPS.MAP.LAYERS.SET_OPTION:
      return setMapLayerOption(state, action.mapKey, action.layerKey, action.optionKey, action.optionValue);

    case ActionTypes.MAPS.MAP.LAYERS.SET_STYLE_KEY:
      return setMapLayerStyleKey(state, action.mapKey, action.layerKey, action.styleKey);

    case ActionTypes.MAPS.MAP.REMOVE:
      return removeMap(state, action.mapKey);

    case ActionTypes.MAPS.MAP.USE.CLEAR:
      return mapUseClear(state, action.mapKey);

    case ActionTypes.MAPS.MAP.USE.REGISTER:
      return mapUseRegister(state, action.mapKey);

    case ActionTypes.MAPS.MAP.VIEW.UPDATE:
      return updateMapView(state, action.mapKey, action.update);

    case ActionTypes.MAPS.MAP.VIEWPORT.SET:
      return setMapViewport(state, action.mapKey, action.width, action.height);

    case ActionTypes.MAPS.MAP.SET_BACKGROUND_LAYER:
      return setMapBackgroundLayer(state, action.mapKey, action.backgroundLayer);

    case ActionTypes.MAPS.SET.ADD:
      return addMapSet(state, action.mapSet);

    case ActionTypes.MAPS.SET.ADD_MAP:
      return addMapToSet(state, action.mapKey, action.mapSetKey);

    case ActionTypes.MAPS.SET.REMOVE:
      return removeMapSet(state, action.mapSetKey);

    case ActionTypes.MAPS.SET.REMOVE_MAP:
      return removeMapFromSet(state, action.setKey, action.mapKey);

    case ActionTypes.MAPS.SET.SET_ACTIVE_MAP_KEY:
      return setSetActiveMapKey(state, action.setKey, action.mapKey);

    case ActionTypes.MAPS.SET.SET_BACKGROUND_LAYER:
      return setSetBackgroundLayer(state, action.setKey, action.backgroundLayer);

    case ActionTypes.MAPS.SET.SET_SYNC:
      return setMapSetSync(state, action.mapSetKey, action.sync);

    case ActionTypes.MAPS.SET.LAYERS.SET:
      return setSetLayers(state, action.setKey, action.layers);

    case ActionTypes.MAPS.SET.USE.CLEAR:
      return mapSetUseClear(state, action.mapSetKey);

    case ActionTypes.MAPS.SET.USE.REGISTER:
      return mapSetUseRegister(state, action.mapSetKey);

    case ActionTypes.MAPS.SET.VIEW.UPDATE:
      return updateSetView(state, action.setKey, action.update);

    case ActionTypes.MAPS.SET_ACTIVE_MAP_KEY:
      return setActiveMapKey(state, action.mapKey);

    case ActionTypes.MAPS.UPDATE:
      return update(state, action.data);

    default:
      return state;
  }
}